/* pl-datalayer — emite view_item_list e add_to_cart no dataLayer, pelo TEMA.

   POR QUE EXISTE (medido em 19/08/2026, depois da publicacao do tema novo):

   O tema nunca emitiu evento de ecommerce. Busca no repo e no bundle da
   agencia: ZERO ocorrencias de `dataLayer` e de `view_item_list`. Quem emitia
   era o GTM/Stape, por seletor de CSS — e seletor quebra quando o layout muda.

   Medido no dataLayer da loja publicada, home e colecao:

     home     -> page_view_stape, gtm.js, gtm.dom, gtm.load
     colecao  -> os mesmos + view_collection_stape

   `view_item_list` NAO aparece em nenhuma das duas. E o add_to_cart so era
   observado na navegacao seguinte ao clique, nao no clique — assinatura de
   gatilho preso a pageview.

   O QUE ESTE ARQUIVO RESOLVE, e o que nao resolve:

   Resolve a fragilidade: os dados saem do proprio markup do produto, no
   momento certo, sem depender de seletor de layout. Se a home mudar de
   estrutura de novo, isto continua funcionando — o que nao era verdade antes.

   NAO substitui o Web Pixel do Stape, que roda em sandbox isolado e nao e
   observavel daqui. Se houver evento duplicado depois disto, a deduplicacao e
   no GTM (comparar event_id), nao aqui.

   DE ONDE VEM O DADO — nenhum Liquid novo foi preciso:
   `snippets/buy-button.liquid` ja emite data-product-id, data-variant-id,
   data-product-title e data-price em cada card. Verificado na home publicada:
   99 de 99 cards tinham os quatro. Ler dali evita somar bytes por card numa
   pagina que ja tem 2 MB.

   ⚠️ PRECO: data-price vem em CENTAVOS (10489 = R$ 104,89). Dividir por 100.
*/

(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  var MOEDA = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL';
  var enviados = {}; // lista -> true, para nao repetir view_item_list

  function num(v) {
    var n = parseFloat(v);
    return isFinite(n) ? n : 0;
  }

  /* O botao de compra carrega os dados do produto. Nos cards ele fica DENTRO
     do article; na PDP, dentro do main-product. */
  function dadosDo(el) {
    var b = el.querySelector('[data-product-id][data-price]');
    if (!b) return null;
    return {
      item_id: b.getAttribute('data-product-id') || '',
      item_variant: b.getAttribute('data-variant-id') || '',
      item_name: b.getAttribute('data-product-title') || '',
      price: num(b.getAttribute('data-price')) / 100
    };
  }

  /* Nome da lista = titulo visivel da secao. E o que o relatorio do GA4 mostra,
     entao precisa ser legivel por humano, nao o id da secao. */
  function nomeDaLista(secao) {
    if (!secao) return 'Lista sem titulo';
    var h = secao.querySelector('h1, h2, h3');
    var t = h && h.innerText ? h.innerText.trim() : '';
    return t ? t.slice(0, 80) : (secao.id || 'Lista sem titulo');
  }

  /* ---------- view_item_list ---------- */

  /* Dispara UMA vez por secao, quando a primeira carta dela aparece. Agrupar
     por secao (e nao por carta) e o que faz o evento corresponder ao que o GA4
     chama de "lista": um carrossel = uma lista. */
  function observarListas() {
    var cards = document.querySelectorAll('article.product-card');
    if (!cards.length || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          var secao = e.target.closest('[id^="shopify-section"]');
          var chave = secao ? secao.id : 'sem-secao';
          if (enviados[chave]) return;
          enviados[chave] = true;

          var lista = nomeDaLista(secao);
          var itens = [];
          var doSetor = secao
            ? secao.querySelectorAll('article.product-card')
            : [e.target];

          Array.prototype.forEach.call(doSetor, function (c, i) {
            var d = dadosDo(c);
            if (!d) return;
            d.index = i + 1;
            d.item_list_name = lista;
            itens.push(d);
          });
          if (!itens.length) return;

          window.dataLayer.push({
            event: 'view_item_list',
            ecommerce: {
              currency: MOEDA,
              item_list_name: lista,
              items: itens
            }
          });
        });
      },
      /* 25% visivel: alto o bastante para nao contar carta que so raspou a
         borda da tela, baixo o bastante para carrossel horizontal contar. */
      { threshold: 0.25 }
    );

    Array.prototype.forEach.call(cards, function (c) {
      io.observe(c);
    });
  }

  /* ---------- add_to_cart ---------- */

  /* Delegacao no document: pega tambem carta que entrou depois (carrossel que
     recarrega, troca de variante, Section Rendering API). Listener por botao
     perderia essas. */
  function observarCliques() {
    document.addEventListener(
      'click',
      function (ev) {
        var alvo = ev.target.closest
          ? ev.target.closest('[data-product-id][data-price]')
          : null;
        if (!alvo) return;

        /* botao que so leva para a PDP nao e adicao ao carrinho */
        if (alvo.hasAttribute('data-pdp-link')) return;
        if (alvo.getAttribute('data-available') === 'false') return;

        var preco = num(alvo.getAttribute('data-price')) / 100;
        var qtd = num(alvo.getAttribute('data-quantity')) || 1;

        window.dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            currency: MOEDA,
            value: preco * qtd,
            items: [
              {
                item_id: alvo.getAttribute('data-product-id') || '',
                item_variant: alvo.getAttribute('data-variant-id') || '',
                item_name: alvo.getAttribute('data-product-title') || '',
                price: preco,
                quantity: qtd
              }
            ]
          }
        });
      },
      /* captura: dispara antes de qualquer handler do bundle que possa
         parar a propagacao do evento */
      true
    );
  }

  /* ---------- esperar o Stape antes de empurrar no carregamento ---------- */

  /* A ESPERA — o que ela faz, o que ela NAO faz, e por que fica.

     MEDIDO em producao em 20/08, tema publicado, aba visivel (as medicoes
     anteriores em aba oculta nao valiam: IntersectionObserver nao dispara em
     documento oculto, entao o script nao empurrava nada e o teste media o vazio):

       ordem no dataLayer -> gtm.js, gtm.dom, gtm.load, 8x view_item_list
       8 secoes, 8 nomes distintos, itens 12/9/12/12/12/11/10/10
       page_view_stape -> AUSENTE

     Duas conclusoes, e a segunda desmente o que eu escrevi antes neste mesmo
     arquivo:

     1. A espera FUNCIONA. Antes dela o view_item_list caia no indice 0, antes do
        gtm.js. Agora vem depois do gtm.load.

     2. E nao resolve o page_view_stape. A entrada continua ausente com a espera
        ativa. Ordem nao era a causa. Eu havia escrito aqui que a espera "cobre o
        risco" de uma tag do GTM presa ao nome page_view_stape — isso e FALSO, e
        foi escrito sem teste, poucas horas depois de errar do mesmo jeito.

     🚨 E NAO HA PERDA DE DADO. Payload do hit decodificado na mesma carga:

       /g/collect?v=2&tid=G-RJHMEPP4F9 ... &en=page_view
         &dl=<home> &dt=<titulo> &cid=... &sid=... &sct=6 &seg=1
         &sst.etld &sst.tft &sst.navt   <- passou pelo container server-side

     `en=page_view`. O GA4 recebe o pageview da home com titulo, URL, client id e
     sessao corretos, com e sem este script. Sumir do array nao e sumir da rede.

     POR QUE A ESPERA FICA: custa nada (view_item_list nao e sensivel a atraso) e
     por a nossa emissao depois do gtm.load e a ordem convencional. Tirar exigiria
     outro ciclo de teste em producao para ganho zero.

     HIPOTESE NAO TESTADA: o teto de 5s e curto. Nas medicoes o page_view_stape
     chega tarde, 8-12s nessa home, entao a espera estoura e empurra antes dele de
     todo jeito. O gatilho certo seria o primeiro scroll do usuario, nao um timer.
     Nao perseguido de proposito: so recuperaria uma linha num array.

     ⚠️ O QUE FALTA NAO E AQUI. Na mesma carga NAO existe /g/collect com
     `en=view_item_list`. Os 8 eventos estao no dataLayer e nada os consome: falta
     gatilho de evento personalizado no container WEB (GTM-MNCZSK8P) mais a tag do
     GA4. Tem de ser no web — so ele le o window.dataLayer; o server container
     (gtm.plenitudedistribuidora.com.br) recebe o que o web manda e nao ve o
     array. Nada a fazer no tema. Confirmar pelo Relatorio em Tempo Real do GA4.
     Mesma coisa para o add_to_cart, com dedup por event_id contra add_to_cart_stape.

     LICAO: array nao e rede. Validar sempre pelo `en=` do /g/collect, nunca por
     entrada ausente no dataLayer. Errei isso duas vezes em dois dias. */
  function quandoStapeJaPassou(cb) {
    function passou() {
      return window.dataLayer.some(function (x) {
        return x && /_stape$/.test(x.event || '');
      });
    }
    if (passou()) return cb();

    /* Teto de 5s: se o Stape nao carregar (bloqueador, rede ruim), emite mesmo
       assim. Evento nosso atrasado e melhor que evento nosso nunca. */
    var tentativas = 0;
    var iv = setInterval(function () {
      if (passou() || ++tentativas > 50) {
        clearInterval(iv);
        cb();
      }
    }, 100);
  }

  function iniciar() {
    /* Cliques podem ser ligados JA: o usuario clica muito depois do load, e a
       essa altura o Stape ja empurrou. Gatear isto so criaria janela cega. */
    observarCliques();

    /* view_item_list e o unico que dispara no carregamento — e o unico que
       precisa esperar. */
    quandoStapeJaPassou(observarListas);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
